




















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";
import { MathHelper } from '@/helper/mathHelper';

import { ColorConstruct } from "@/utilityModels/colorConstruct";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextShadowColorController extends Vue 
{
    @Prop() layer! : DateTextLayer;

    private getTextInfo(name : string)
    {
        return this.layer.textInfo[name];
    }

    private invisibleColor()
    {
        var value = this.getTextInfo("isShadow");
        if(value == null || value === true)
        {
            this.changeTextInfo("isShadow", false, true, true);
        }
    }

    private requestColor()
    {
        var textColor = this.getTextInfo("shadowColor");
        var current = textColor != null ? textColor : new ColorConstruct();
        this.$emit("requestColor", "shadowColor", current);
    }

    private changeColor(hex : string)
    {
        var hexContent = hex.substr(0, 1) == "#" ? hex.substr(1, 6) : hex; 
        var r = parseInt(hexContent.substr(0, 2), 16);
        var g = parseInt(hexContent.substr(2, 2), 16);
        var b = parseInt(hexContent.substr(4, 2), 16);

        this.changeTextInfo("isShadow", true, false, false);
        this.changeTextInfo("shadowColor", new ColorConstruct(r,g,b), true, false);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
